exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cari-hesap-report-table[data-v-2b65d459],.cari-hesap-report-table>*[data-v-2b65d459]{width:100%}", ""]);

// exports
